export default "assets/images/arion-fc9fd8bc.svg";